import React from 'react';
import QRCode from 'qrcode.react';
import {generateCawiUrl} from '../../../utils/urls';
import ClipboardCopyInput from '../../ClipboardCopyInput';

const CawiInfo = ({surveyId}) => (
    <div className="text-center">
        <QRCode value={generateCawiUrl(surveyId)} size={256} level="M" className="my-4" />
        <ClipboardCopyInput readOnly value={generateCawiUrl(surveyId)} />
    </div>
);

export default CawiInfo;
